(function () {
  if (window.__pnpSuggest) return;
  window.__pnpSuggest = true;

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var el = document.getElementById('cart-icon-bubble');
        var html = data && data['cart-icon-bubble'];
        if (!el || !html) return;
        var inner = parse(html).querySelector('.shopify-section');
        if (inner) el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  // On the cart page: refresh the suggestion list and the totals footer after an add.
  function refreshCartPage() {
    var wraps = {};
    document.querySelectorAll('main .shopify-section').forEach(function (w) {
      var key = w.id.replace('shopify-section-', '');
      if (/__cart-suggestions$/.test(key)) wraps.suggest = { wrap: w, key: key };
      if (/__cart-footer$/.test(key)) wraps.footer = { wrap: w, key: key };
    });
    var keys = Object.keys(wraps).map(function (k) { return wraps[k].key; });
    if (!keys.length) return;
    var base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(base + '?sections=' + keys.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (wraps.suggest && data[wraps.suggest.key]) {
          var s = parse(data[wraps.suggest.key]).querySelector('.shopify-section');
          if (s) wraps.suggest.wrap.innerHTML = s.innerHTML;
        }
        if (wraps.footer && data[wraps.footer.key]) {
          var f = parse(data[wraps.footer.key]);
          var fresh = f.querySelectorAll('.js-contents');
          wraps.footer.wrap.querySelectorAll('.js-contents').forEach(function (el, i) {
            if (fresh[i]) el.innerHTML = fresh[i].innerHTML;
          });
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pnp-suggest-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added';
        refreshBubble();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pnp-suggestions' });
        }
        setTimeout(refreshCartPage, 900);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  });
})();
